import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import { useDebounce } from "../../helpers/use-debounce";

export default function SearchBox({ setQueryString }) {
  const { phrases } = window;
  const { register, watch } = useForm();
  const queryString = useDebounce(watch("searchStore"), 500);

  useEffect(() => {
    if (queryString && queryString.length > 1) {
      const sanitizedQueryString = queryString.toLowerCase().trim();
      setQueryString(sanitizedQueryString);
    } else if (!queryString) {
      setQueryString(null);
    }
  }, [queryString]);

  return (
    <input
      autoComplete="off"
      type="text"
      // name="searchStore"
      className="search-input"
      placeholder={phrases?.product?.['store_selector_search_placeholder'] || "City, address or shopping center"}
      {...register("searchStore")}
    />
  );
}
